import React from 'react';

import PlainSearchInput, {ClearType} from 'ui-library/PlainSearchInput';

interface Props {
  value: string;
  updateValue: (val: string) => void;
}

// Inspired by swagger-ui/src/core/containers/filter.jsx
export default function Filter(props: Props): JSX.Element {
  const {value, updateValue} = props;

  return (
    <div className="filter-container">
      <PlainSearchInput
        clearType={ClearType.X}
        shouldAutoSelect={false}
        placeholder="Filter"
        value={value == null ? '' : value}
        onChange={(e) => {
          const {
            target: {value},
          } = e;

          updateValue(value);
        }}
        onEscape={() => {
          updateValue('');
        }}
      />
    </div>
  );
}
